import {
  ShippingAddressListResponse,
  ShippingAddressResponse,
} from "@API/src/component/memoruHome/shippingAddress/types";

export const isTypeShippingAddressListResponse = (
  arg
): arg is ShippingAddressListResponse =>
  arg !== null && typeof arg === "object";

export const isTypeShippingAddressResponse = (
  arg
): arg is ShippingAddressResponse =>
  arg !== null &&
  typeof arg === "object" &&
  typeof (arg as ShippingAddressResponse).firstName === "string" &&
  typeof (arg as ShippingAddressResponse).lastName === "string" &&
  typeof (arg as ShippingAddressResponse).firstNameKana === "string" &&
  typeof (arg as ShippingAddressResponse).lastNameKana === "string" &&
  typeof (arg as ShippingAddressResponse).phoneNumber === "string" &&
  typeof (arg as ShippingAddressResponse).postalCode === "string" &&
  typeof (arg as ShippingAddressResponse).prefecture === "string" &&
  typeof (arg as ShippingAddressResponse).city === "string";
